{
  "error-handler-service": {
    "backend-message": {
      "customer": {
        "blackListed": "Your online booking option at this salon is blocked. Please contact the salon to book a new appointment",
        "existed": "Account is already existed",
        "notFound": "Account cannot be found",
        "credentialNotMatched": "PIN code is invalid. Please try again!",
        "numberOfCredentialFailedMatchesAlreadyExceedMax": "Number of retries is exceeded. Please contact to studio for further supports",
        "customerNumberOfCredentialResendExceedMax": "Number of retries is exceeded. Please contact to studio for further supports",
        "waitingPeriodBeforeResendNotOverYet": "Please be patient until you can resend the PIN code after about one minute"
      },
      "businessObject": {
        "alreadyCheckedIn": "Already checked in. Please try again after a few minutes",
        "notFound": "Studio cannot be found"
      },
      "credit-package-order": {
        "no-capture-payments": "Credit package order failed",
        "order-already-fulfilled": "Credit package order was already fulfilled",
        "order-already-rejected": "Credit package order was rejected"
      },
      "email": {
        "exists-confirmed-and-not-changeable": "Once an email has been confirmed, it can no longer be changed!"
      },
      "error": {
        "email-exists": "For security reasons, we accept a unique email associated with a unique phone number. Your phone number is associated with an email that is already in use. Please try to log in with your email.",
        "invalid-code": "PIN code is invalid. Please try again!",
        "phoneNr-exists": "For security reasons, we accept a unique email associated with a unique phone number. Your email is associated with a phone number that is already in use. Please try to log in with your phone number."
      },
      "review": {
        "notFound": "Invalid or expired URL"
      },
      "startTime": {
        "invalid": "The selected time slot is no longer available. Please choose another time slot!"
      },
      "Unauthorized": "Please login again with correct email and password!",
      "user-challenge": {
        "too-much-requests": "You have requested frequently. Please try again after a few seconds"
      },
      "appointment duration is too long, max 4 hours": "The maximum duration is 4 hours. Please change your selected services.",
      "No available slot at desired start time": "The selected time slot is no longer available. Please choose another time slot!",
      "confirmed appointment already exists at same time": "You have already booked an appointment at the same time",
      "customer already has maximum number of confirmed appointments": "The maximum number of appointments in this salon has been reached. Please contact the salon to book a new appointment"
    },
    "text": {
      "server-connection-error": "No connection to the server",
      "general-error": "Oops! Something went wrong. Please try again at a later time."
    }
  }
}
